import ExpiredCard from 'features/advance/screens/registration/ExpiredCard/ExpiredCard';
import React from 'react';

export default function ExpiredCardPage() {
  return <ExpiredCard />;
}
